/* Top level history page. This page should get all titles from MongoDB and show them. Upon
   clicking on a title, a component should then show that entry. That component should be
   re-used on any page where a history entry needs to be shown. */

import React, { useEffect, useState }  from 'react'
import axios                           from 'axios'
import Box                             from "@material-ui/core/Box"
import { CLIENT_PUBLIC_TOKEN }         from '../config.js'
import Grid                            from "@material-ui/core/Grid"
import { node_server }                 from '../Helpers/index.js'
import Paper                           from "@material-ui/core/Paper"
import Typography                      from "@material-ui/core/Typography"

import HistoryReadComponent            from '../Components/HistoryReadComponent.js'
import HistoryTitles                   from '../Components/HistoryTitles.js'

const HistoryDeletePage = () => {

   const [ id,             setId             ]  =  useState('')
   const [ showEntry,      setShowEntry      ]  =  useState(false)

   const handleClick = (id) => {
      console.log('<HistoryDeletePage /> you clicked id', id)
      setId(id)
      axios.defaults.headers.common = {Accept: "application/json, text/plain, */*", 'Authorization': `Bearer ${CLIENT_PUBLIC_TOKEN}`}
      axios.delete(node_server + `history/${id}`)
         .then( res => res.data )
         .then( data => {
console.log('<HistoryDeletePage data is', data)
         })
         .catch( ( error, msg ) => {
            console.log('error and msg are', error, msg)
         } )
   }

   return (
      <Box>
         <HistoryTitles handleClick={handleClick} id={id} page={'HistoryDeletePage'} />
      </Box>
   )
}

export default HistoryDeletePage
